import type { FileIconProps } from './FileIcon';

function FileThirdPartyIcon({ color, size = 28, ...props }: FileIconProps) {
  return (
    <svg width={size} height={size * 1.25} fill='none' {...props}>
      <path d='M4 35h20a4 4 0 004-4V10L18 0H4a4 4 0 00-4 4v27a4 4 0 004 4z' fill={color} />
      <path opacity={0.4} d='M18 10V0l10 10H18z' fill='#fff' />
      <g opacity={0.4} stroke='#fff' strokeWidth={1.5} strokeLinecap='round' strokeLinejoin='round'>
        <path d='M9.25 25.125a3.126 3.126 0 004.713.337l1.875-1.875a3.125 3.125 0 00-4.42-4.418l-1.074 1.069' />
        <path d='M11.75 23.875a3.125 3.125 0 00-4.713-.337l-1.875 1.875a3.125 3.125 0 004.42 4.418l1.068-1.069' />
      </g>
    </svg>
  );
}

export default FileThirdPartyIcon;
